import { render, staticRenderFns } from "./PrehledTrzebDlePlatbyZaObdobi.vue?vue&type=template&id=58346814&"
import script from "./PrehledTrzebDlePlatbyZaObdobi.vue?vue&type=script&lang=ts&"
export * from "./PrehledTrzebDlePlatbyZaObdobi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports